<!--采购合同变更-->
<template>
  <div class="approval-container">
    <van-nav-bar title="采购合同变更审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="modifyInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">变更内容查看</span>
        </template>
        <modify-info
          ref="modifyInfo"
          :master="headInfo"
          :product-list="productList"
          :pay-stage-list="payStageList"
        ></modify-info>
      </van-collapse-item>
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">合同信息</span>
        </template>
        <base-info :head-info="headInfo" :contract-type-list="contractTypeList" />
      </van-collapse-item>
      <van-collapse-item name="materialDetails">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">产品信息</span>
        </template>
        <product-details ref="productDetails" :details-list="productList" />
      </van-collapse-item>
      <van-collapse-item name="paymentPlan">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">合同付款阶段</span>
        </template>
        <payment-plan ref="paymentPlan" :pay-stage-list="payStageList" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="contractAttachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">合同附件</span>
        </template>
        <div class="order-card">
          <van-row class="order-title">合同正文</van-row>
          <hi-attachment :attach-list="nonStampedContractFiles"></hi-attachment>
        </div>
        <div class="order-card">
          <van-row class="order-title">补充协议</van-row>
          <hi-attachment :attach-list="nonStampedProtocolFiles"></hi-attachment>
        </div>
        <div class="order-card">
          <van-row class="order-title">其他附件</van-row>
          <hi-attachment :attach-list="nonStampedOtherFiles"></hi-attachment>
        </div>
      </van-collapse-item>
      <van-collapse-item name="stampedContractAttachment" v-if="headInfo.contractModifyMode !== '3'">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">合同盖章附件</span>
        </template>
        <div v-if="headInfo.contractModifyMode === '1'" class="order-card">
          <van-row class="order-title">合同正文</van-row>
          <hi-attachment :attach-list="stampedContractFiles"></hi-attachment>
        </div>
        <div v-if="headInfo.contractModifyMode === '2'" class="order-card">
          <van-row class="order-title">补充协议</van-row>
          <hi-attachment :attach-list="stampedProtocolFiles"></hi-attachment>
        </div>
        <div v-if="headInfo.contractModifyMode === '2'" class="order-card">
          <van-row class="order-title">其他附件</van-row>
          <hi-attachment :attach-list="stampedOtherFiles"></hi-attachment>
        </div>
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval :page-context="thisPage" @get-process-info="onGetProcessInfo" />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import Bridge from '@/components/dsbridge'
import {
  coopPayCreateHead,
  getAllContractType,
  getApprovalLevel,
  selectPayStageData,
  selectProductDetail
} from '@/api/PurchaseContractChange'
export default {
  name: 'PurchaseContractChangeApproval',
  components: {
    'modify-info': () => import('./components/ModifyInfo.vue'),
    'base-info': () => import('./components/BaseInfo.vue'),
    'product-details': () => import('./components/ProductDetails.vue'),
    'payment-plan': () => import('./components/PaymentPlan.vue')
  },
  data() {
    return {
      activeNames: ['modifyInfo', 'approvalOpinions'],
      poCreateHeadId: this.$route.query.businessKey,
      headInfo: {},
      attachList: [],
      nonStampedContractFiles: [],
      nonStampedProtocolFiles: [],
      nonStampedOtherFiles: [],
      stampedContractFiles: [],
      stampedProtocolFiles: [],
      stampedOtherFiles: [],
      productList: [],
      payStageList: [],
      contractTypeList: [],
      taskDefKey: ''
    }
  },
  computed: {
    thisPage() {
      return this
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      const modifyDataResp = await coopPayCreateHead(this.poCreateHeadId)
      this.headInfo = modifyDataResp.data
      this.attachList = this.headInfo.contractModifyApplyFiles
      this.nonStampedContractFiles = this.headInfo.nonStampedContractFiles
      this.nonStampedProtocolFiles = this.headInfo.nonStampedProtocolFiles
      this.nonStampedOtherFiles = this.headInfo.nonStampedOtherFiles
      this.stampedContractFiles = this.headInfo.stampedContractFiles
      this.stampedProtocolFiles = this.headInfo.stampedProtocolFiles
      this.stampedOtherFiles = this.headInfo.stampedOtherFiles
      await this.$refs.modifyInfo.initData(this.headInfo.sourceContractUuid)
      const productData = await selectProductDetail({ applyId: this.poCreateHeadId })
      this.productList = productData.data
      const payStageData = await selectPayStageData({ applyId: this.poCreateHeadId })
      this.payStageList = payStageData.data
      const contractTypeData = await getAllContractType({ activeMode: '' })
      this.contractTypeList = contractTypeData.data
    },
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    },
    onGetProcessInfo(processInfo) {
      this.taskDefKey = processInfo.taskDefKey
    },
    $stopExecute() {
      throw Error()
    }
  },
  bpmHooks: {
    async setProcessVariables(type) {
      if (type === 'agree') {
        if (this.taskDefKey === 'Activity_047a8ve') {
          // 采购履行部主任审批
          let approvalLevelRes = ''
          const response = await getApprovalLevel(this.poCreateHeadId)
          if (response.success) {
            approvalLevelRes = response.data
          } else {
            this.$notify({
              title: '提示',
              message: response.message,
              type: 'warning'
            })
            this.$stopExecute()
          }
          return {
            businessKey: this.poCreateHeadId,
            approvalLevel: approvalLevelRes,
            opType: type,
            corpCode: this.headInfo.corpId
          }
        } else {
          return {
            businessKey: this.poCreateHeadId,
            opType: type,
            corpCode: this.headInfo.corpId
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
.order-card {
  border: 1px solid #969799;
  border-radius: 10px;
  padding: 0 10px 10px 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.order-title {
  color: #323233;
  font-weight: bold;
  margin: 10px 0;
  font-size: 16px;
}
</style>
